import React, { useEffect, useState } from 'react';

import './style.less';

const Questions = ({ productID }) => {
  const [siteLocale, setSiteLocale] = useState('');

  useEffect(() => {
    setSiteLocale(window.config.locale);
  }, [window.config.locale]);

  return (
    <React.Fragment>
    {
      siteLocale === 'da_DK' &&
        <div id="bv-rating">
          <div className="questions-wrapper">
            <div data-bv-show="questions" data-bv-product-id={productID} />
          </div>
        </div>
    }
    </React.Fragment>
  );
};

export default Questions;
